import store from '../store'

const base = {
  // 逾期账龄
  overdueAge: [
    { value: 1, label: 'M1' },
    { value: 2, label: 'M2' },
    { value: 3, label: 'M3' },
    { value: 4, label: 'M4' },
    { value: 5, label: 'M5' },
    { value: 6, label: 'M6+' }
  ],

  // 催收状态
  urgeStatus: [
    { value: 1, label: '在催' },
    { value: 2, label: '出催' }
  ],

  // 催收阶段
  urgeStage: [
    { value: 1, label: '自催' },
    { value: 2, label: '委外' },
    { value: 3, label: '诉讼' }
  ],

  // 催收队列
  urgeQueue: [
    { value: 1, label: '自催' },
    { value: 2, label: '待委' },
    { value: 3, label: '委外中' },
    { value: 4, label: '留案中' },
    { value: 5, label: '待诉' },
    { value: 6, label: '起诉中' },
    { value: 7, label: '停留' }
  ],

  // //还款状态
  // repaymentStatus: [
  //   { value: 1, label: '待审批' },
  //   { value: 2, label: '审批通过' },
  //   { value: 3, label: '审批拒绝' },
  //   { value: 4, label: '有效' },
  //   { value: 5, label: '失效' },
  //   { value: 6, label: '已结清' }
  // ],
  //扣款方式
  chargeMethods: [
    { value: 1, label: '代扣' },
    { value: 2, label: '转账' },
    { value: 3, label: '混合' }
  ],
  //还款类型
  // repaymentType: [
  //   { value: 1, label: '提前还款' },
  //   { value: 2, label: '正常到期还款' },
  //   { value: 3, label: '逾期还款' },
  //   { value: 4, label: '紧急收回' }
  // ],
  //应用平台
  applyPlatform: [
    { value: 1, label: '徙木' },
    { value: 2, label: '场景方' },
    { value: 3, label: '资金方' },
    { value: 4, label: '数据方' },
    { value: 5, label: '第三方支付' },
    { value: 6, label: '电子签名平台' },
    { value: 7, label: '短信平台' },
    { value: 8, label: '催收机构' },
    { value: 9, label: '银企直连' },
    { value: 10, label: '其它' },
    { value: 11, label: '保险机构' },
    { value: 12, label: '身份核实与实名认证' },
    { value: 13, label: '决策使用方' }
  ],
  checkState: [
    { value: 10, label: '待提交' },
    { value: 11, label: '审核拒绝/待提交' },
    { value: 20, label: '审核通过' },
    { value: 21, label: '审核拒绝' },
    { value: 22, label: '已提交/待审核' },
    { value: 23, label: '复核拒绝/待审核' },
    { value: 30, label: '复核通过' },
    { value: 31, label: '复核拒绝' },
    { value: 32, label: '审核通过/待复核' }
  ],
  // 平台
  platform: [
    { value: 1, label: '贷款' },
    { value: 2, label: '保理' },
    { value: 3, label: '其它' }
  ],

  //开放模式
  openModel: [
    { value: 1, label: '白名单邀请制' },
    { value: 2, label: '全开放' }
  ],
  //客户类型
  customerType: [
    { value: 1, label: '企业客户' },
    { value: 2, label: '个人客户' }
  ],
  //状态
  fundState: [
    { value: 0, label: '禁用' },
    { value: 1, label: '正常' }
  ],
  //认证状态
  certifyFlag: [
    { value: 0, label: '未认证' },
    { value: 1, label: '认证中' },
    { value: 2, label: '已认证' },
    { value: 3, label: '认证失败' },
    { value: 4, label: '重新认证中' }
  ],
  //申请状态
  applyState: [
    { value: 1, label: '审核中' },
    { value: 2, label: '审核通过' },
    { value: 3, label: '审核拒绝' }
  ],
  //贷款状态
  loanState: [
    { value: 1, label: '未放款' },
    { value: 2, label: '放款中' },
    { value: 3, label: '放款成功' },
    { value: 4, label: '已还款' },
    { value: 5, label: '逾期转催收' },
    { value: 6, label: '部分还款' }
  ],
  //产品类型
  productType: [
    { value: 1, label: '信用贷' },
    { value: 2, label: '保理贷' },
    { value: 3, label: '仓单贷' },
    { value: 4, label: '其它' }
  ],
  //交易状态
  transState: [
    { value: 1, label: '还款确认中' },
    { value: 2, label: '已还款' },
    { value: 3, label: '还款失败' }
  ],
  // 还款方式
  repaymentType: [
    { value: 1, label: '线下还款' },
    { value: 2, label: '线上还款' }
  ],
  // 签章审核状态
  signType: [
    { value: 10, label: '待提交' },
    { value: 11, label: '拒绝/待编辑' },
    { value: 12, label: '编辑/待提交' },
    { value: 13, label: '撤回/待提交' },
    { value: 20, label: '审核通过' },
    { value: 21, label: '审核拒绝' },
    { value: 22, label: '待审核' },
    { value: 23, label: '复核拒绝/待审核' },
    { value: 30, label: '复核通过' },
    { value: 31, label: '复核拒绝' },
    { value: 32, label: '审核通过/待复核' }
  ],
  // 短信模板状态
  messageType: [
    { value: 0, label: '验证码' },
    { value: 1, label: '短信通知' },
    { value: 2, label: '推广短信' },
    { value: 3, label: '国际/港澳台消息' },
  ],
  sysRole:[
    { value: 32, label: '总后台管理' },
    { value: 33, label: '场景方' },
    { value: 34, label: '资金方' },
  ]
}

export function createWordbooks() {
  const res = {}
  if (store.getters.wordbooks.length) {
    store.getters.wordbooks.forEach(item => {
      res[item.type] = item.subList
    })
    return Object.assign(base, res)
  } else {
    return {}
  }
}
export function stateMatching(state, arr) {
  if(arr&&arr.length>0){
    const newArr = arr.filter(item => {
        return item.value == state
    })
    if(newArr.length>0){
       return newArr[0].label
    }else{
      return ''
    }

  } else {
    return ''
  }
}

export default {
  ...base,
  ...createWordbooks(),
  stateMatching
}
